import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// Create feedback
export const createSoundTherapyFeedback = async (data) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/sound-therapy-feedback/create`,
            data
        );
        return response.data;
    } catch (error) {
        console.error("Error creating feedback:", error.response?.data || error.message);
        throw error.response?.data || { error: "Something went wrong" };
    }
};

// List feedback by user ID
export const getSoundTherapyFeedbackByUserId = async (userId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/sound-therapy-feedback/user/${userId}`
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching feedback:", error.response?.data || error.message);
        throw error.response?.data || { error: "Something went wrong" };
    }
};